// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1705":"PrototypeViewer","2348":"livekit-egress-template"}[chunkId] || chunkId) + "." + {"1705":"e805520a204d4b9bec3c","1871":"fffb7ac1d481441d9602","2348":"b8db09b550a9f97a1399","2710":"e89a8605001f8bb55dc8","4969":"e805520a204d4b9bec3c","6781":"ca98efd6168385d4fdfd"}[chunkId] + ".chunk.css";
};